import { render, staticRenderFns } from "./VendorInformation.vue?vue&type=template&id=e5317d2c&scoped=true&"
import script from "./VendorInformation.vue?vue&type=script&lang=js&"
export * from "./VendorInformation.vue?vue&type=script&lang=js&"
import style0 from "./VendorInformation.vue?vue&type=style&index=0&id=e5317d2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5317d2c",
  null
  
)

component.options.__file = "VendorInformation.vue"
export default component.exports